import { Typography } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import Api from "../API/api";
import { loginState, WHState } from "../Atom/AtomState";
import "../CSS/PageCSS/NoticePage.css";
import AlertComponent from "../CommonComponent/Alert/AlertComponent";
import ButtonComponent from "../CommonComponent/Inputs/ButtonComponent";
import TextComponent from "../CommonComponent/Inputs/TextComponent";
import Loading from "../CommonComponent/LoadingBar/Loading";
import PublicModal from "../CommonComponent/Modal/PublicModal";
import TableComponent from "../CommonComponent/Tables/TableComponent";

const { Title } = Typography;

export default function NoticePage() {
  let navigate = useNavigate();
  const WH = useRecoilValue(WHState);
  const LoginState = useRecoilValue(loginState);
  const [divboxHeight, setdivBoxHeight] = useState<number>(0);
  const [searchInformation, setSearchInformation] = useState({
    title: "",
  });
  const [alert, setAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [noticeData, setNoticeData] = useState<any>();
  const [deleteModal, setDeleteModal] = useState({
    value: false,
    p_id: 0,
  });
  const [loading, setLoading] = useState(false);

  const changeTextField = (value: any) => {
    if (value.name == "title") {
      setSearchInformation((prev) => ({
        ...prev,
        title: value.value,
      }));
    }
  };

  const handleSearch = () => {
    const getSearch = async () => {
      setLoading(true);
      const question = await Api.get(
        `/Notice/getNoticeSearch?question=${searchInformation.title}`
      );
      setLoading(false);
      if (question != undefined) {
        setNoticeData(question);
      } else {
        setAlert(true);
        setAlertMessage("데이터 조회에 실패하였습니다.");
      }
    };
    getSearch();
  };

  const handleRegister = () => {
    navigate("/NoticeDetailPage", {
      state: { state: "register" },
    });
  };

  const handleDelete = (item: any) => {
    const getDelete = async () => {
      setLoading(true);
      const deletedata = await Api.delete(`/Notice/deleteNotice?p_id=${item}`);
      setLoading(false);
      if (deletedata != undefined) {
        navigate(0);
      } else {
        setAlert(true);
        setAlertMessage("공지사항 삭제에 실패하였습니다.");
      }
    };
    getDelete();
  };

  useEffect(() => {
    if (!LoginState?.manager) {
      navigate("/");
    } else {
      const getData = async () => {
        setLoading(true);
        const notice = await Api.get("/Notice/getNoticeList");
        setLoading(false);
        if (notice != undefined) {
          setNoticeData(notice);
        } else {
          setAlert(true);
          setAlertMessage("데이터 조회에 실패하였습니다.");
        }
      };
      getData();
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const div = document.getElementById("divbox") as HTMLElement;
      const NoticeSearchTextDiv = document.getElementById(
        "NoticeSearchTextDiv"
      ) as HTMLElement;
      if (div && NoticeSearchTextDiv) {
        setdivBoxHeight(
          div.clientHeight - NoticeSearchTextDiv.clientHeight - 20
        );
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  });

  return (
    <div style={{ height: WH.height - 160 }}>
      <Title level={2} className="NoticeTitle">
        NoticePage
      </Title>
      <div id="divbox">
        <div className="NoticeSearchTextDiv" id="NoticeSearchTextDiv">
          <TextComponent
            variant="filled"
            value={searchInformation.title}
            label="제목"
            name="title"
            placeholder="검색어를 입력해주세요."
            onChange={changeTextField}
            className="NoticeSearch"
          />
          <ButtonComponent
            fullWidth
            variant="contained"
            className="NoticesearchTextDiv_searchButton"
            onClick={handleSearch}
          >
            검색
          </ButtonComponent>
          <ButtonComponent
            fullWidth
            variant="contained"
            onClick={handleRegister}
          >
            등록
          </ButtonComponent>
        </div>
        <TableComponent
          data={noticeData}
          columns={[
            {
              width: "700px",
              header: "제목",
              field: "title",
            },
            {
              width: "100px",
              header: "공지여부",
              field: "show_yn",
              position: "center",
              type: "CheckBoxReadOnly",
            },
            {
              width: "100px",
              header: "작성자",
              field: "name",
              position: "center",
            },
            {
              width: "100px",
              header: "",
              field: "UpdateButton",
              position: "center",
              type: "Button",
              buttonLabel: "수정",
              backgroundColor: "rgb(28, 128, 211)",
            },
            {
              width: "100px",
              header: "",
              field: "CancelButton",
              position: "center",
              type: "Button",
              buttonLabel: "삭제",
              backgroundColor: "rgb(148, 148, 148)",
            },
          ]}
          scrollable={false}
          scrollHeight={divboxHeight}
          className="NoticeTable"
          onButtonClick={(row, id) => {
            if (id == "UpdateButton") {
              navigate("/NoticeDetailPage", {
                state: { p_id: row.p_id, state: "update" },
              });
            } else if (id == "CancelButton") {
              setDeleteModal({
                value: true,
                p_id: row.p_id,
              });
            }
          }}
          onClick={(row) => {
            navigate("/NoticeDetailPage", {
              state: { p_id: row.p_id, state: "view" },
            });
          }}
        />
      </div>
      {deleteModal && (
        <PublicModal
          open={deleteModal.value}
          onClose={(value: any) => {
            if (value) {
              handleDelete(deleteModal.p_id);
            }
            setDeleteModal({
              value: false,
              p_id: 0,
            });
          }}
          message={"삭제하시겠습니까?"}
          cancel={true}
        />
      )}
      {alert && (
        <AlertComponent value={alert} setValue={setAlert} info="error">
          {alertMessage}
        </AlertComponent>
      )}
      {loading && <Loading />}
    </div>
  );
}
